var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('router-link',{staticClass:"popular-category-list-item",attrs:{"to":_vm.to}},[_c('figure',{staticClass:"popular-category-list-item__picture"},[_c('base-image',{staticClass:"popular-category-list-item__image",attrs:{"url":_vm.image,"width":"192","height":"192"}})],1),_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }